import { CreationSource, RedFlagsStatus } from '@core/classes/SharedEnums';
import { CustomerBase } from '@core/classes/_Base/CustomerBase';
import IDVOverride from '@core/classes/PlaidIDVOverride';

export default class CustomerRecord extends CustomerBase {
	createdFrom: CreationSource = CreationSource.Unknown;
	creditBureaursPulled?: any; //FIXME: Make Credit Bureau an actual ENUM
	customerName?: string = null;
	customerNumber?: string = null;
	idvOverride?: IDVOverride[] = [];
	isArchived?: boolean = null;
	isIDVSkipped?: boolean = false;
	/** @deprecated use idvOverride instead */
	plaidIDVOverride?: IDVOverride = new IDVOverride();
	redFlagStatus?: RedFlagsStatus.Blank;
	statusIDV?: any;
	storeCodes?: string[] = [];
	customerApplicationStatus?: any;
	constructor(init?: Partial<CustomerRecord>) {
		super(init);
		if (init) {
			this.customerNumber = init.customerNumber;
			this.customerName = init.customerName;
			this.storeCodes = init.storeCodes;
			this.createdFrom = init.createdFrom ?? CreationSource.Unknown;
			this.redFlagStatus = init.redFlagStatus;
			this.creditBureaursPulled = init.creditBureaursPulled;
			this.statusIDV = init.statusIDV;
			this.plaidIDVOverride = init.plaidIDVOverride;
			this.idvOverride = init.idvOverride?.map(x => new IDVOverride(x)) ?? [];
			this.isIDVSkipped = init.isIDVSkipped;
			this.isArchived = init.isArchived;
			this.customerApplicationStatus = init.customerApplicationStatus;
		}
	}

	/**
	 * @param {CreationSource} createdFrom
	 * @method CREATE the customer; if it matches another customer; it'll return that customer.
	 */
	// async save(createdFrom: CreationSource) {
	//     if (this.isEntity) this.dob = null;
	//     this.createdFrom = createdFrom;
	//     const response = await api.customers.createCustomer(this)
	// }
}
